
















































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import Api from '@/api/revisit'
import PageLayout from '@/components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './config'
import listMixins from '@/mixins/list'
import { download } from '@/utils/util'
import {
	FIRST_VISIT,
	REVISIT_TRACK_SUC,
	REVISIT_TRACK_FAIL,
} from '@/utils/const'
import { ORDER_STATUS_DICT } from '@/web-task/config.ts'
const EXPORT_QUERY_INTERVAL = 2000

@Component({
	name: 'revisitList',
	components: {
		PageLayout,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = columns
	private data: any[] = []
	private visible: boolean = false

	private timer: any = ''
	private fileTimer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false
	private YI_QU_XIAO = ORDER_STATUS_DICT.YI_QU_XIAO

	private get commonStatusMap(): any {
		return Object.assign(
			{},
			this.$store.state.setting.orderStatusMap,
			this.$store.state.setting.conOrderStatusMap
		)
	}

	private get revisitOptStatusList() {
		return this.$store.state.setting.revisitOptStatusList.filter(
			(item: any) => {
				// 30 回访成功 40 回访失败
				return [REVISIT_TRACK_SUC, REVISIT_TRACK_FAIL].includes(item.key)
			}
		)
	}

	private goToDetail(row: any) {
		return `/CommonAiiTask/TasksDetail/${row.orderId}/${FIRST_VISIT}?active=4`
	}

	public getList() {
		return Api.wholeprocess(this.getForm()).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	public activated() {
		this.getList()
	}

	private addTask() {
		this.$router.push('/AiiTasks/addTask')
	}

	private deactivated() {
		clearInterval(this.timer)
	}

	private beforeDestroy() {
		this.fileTimer && clearInterval(this.fileTimer)
	}

	private onTaskAdd() {
		this.resetPage()
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		const startendTime = form.startendTime
		if (startendTime && startendTime[0] && startendTime[1]) {
			form.revisitBeginTime = startendTime[0].format('YYYY-MM-DD')
			form.revisitEndTime = startendTime[1].format('YYYY-MM-DD')
			delete form.startendTime
		}

		return form
	}

	private canAudit(action: any) {
		return action.orderStatus === '04' && this.$auth('taskDetail:auditTask')
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择订单')
			return false
		}
		return true
	}
}
